/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ion-content[_ngcontent-%COMP%]{--overflow:hidden}ion-content[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{width:100%;border:0;height:100%}ion-content[_ngcontent-%COMP%]   ion-item[_ngcontent-%COMP%]{height:21px;--background:transparent}ion-content[_ngcontent-%COMP%]   ion-item[_ngcontent-%COMP%]   ion-icon[_ngcontent-%COMP%]{font-size:var(--icon-small-size)}"];
export { styles as styles };
